module.exports = __webpack_public_path__ + "static/img/YymmLOGO.e791916.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/YymmLOGO.png
// module id = FbD8
// module chunks = 1